export const IconExchange = ({ size = 14 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" stroke="currentColor">
      <path d="M32.71,45.71l-1.41-1.41,10.29-10.29H3v-2h38.59l-10.29-10.29,1.41-1.41,12.71,12.71-12.71,12.71ZM15.29,27.71L2.59,15,15.29,2.29l1.41,1.41L6.41,14h38.59v2H6.41l10.29,10.29-1.41,1.41Z" />
    </svg>
  );
};
